import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface TokenState {
  accessToken: string;
  superAdminAccessToken: string | null;
  refreshToken: string;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setSuperAdminToken: (accessToken: string) => void;
  clearTokens: () => void;
}

const useTokenStore = create<TokenState>()(
  persist(
    (set) => ({
      accessToken: '',
      refreshToken: '',
      superAdminAccessToken: null,
      setTokens: (accessToken: string, refreshToken: string) => {
        set({ accessToken, refreshToken });
      },
      setSuperAdminToken: (accessToken) => {
        set({ superAdminAccessToken: accessToken });
      },
      clearTokens: () => {
        set({ accessToken: '', refreshToken: '', superAdminAccessToken: null });
      }
    }),
    {
      name: 'token-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useTokenStore;
